import { lazy } from 'react';

export const ProposeLocale = lazy(() => import(/* webpackChunkName: "locale-selector" */ './propose'));
